<!--需求流瀑表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="statusList"
          :value.sync="queryParams.promotionName"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
        <a-date-picker
          class="year-picker-css"
          slot="submitYear"
          mode="year"
          format="YYYY"
          :open="isOpen"
          :value="queryParams.submitYear"
          @openChange="onOpenChange"
          @panelChange="panelChange"
        />
        <a-range-picker slot="submitTime" v-model="queryParams.submitTime" valueFormat="YYYY-MM-DD" allowClear />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiAnalysisExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
        <a-button type="primary" @click="handleCompareBtn">差异对比按钮</a-button>
        <div class="compare-date" v-show="dateForm.dateOne">
          所选日期需求差异值=日期<span class="choose-data">{{ dateForm.dateOne }}</span>的数值 - 日期<span class="choose-data">{{ dateForm.dateTwo }}</span>的数值
        </div>
        <comparative-analysis ref="comparativeAnalysisRef" @chooseDate="handleChooseDate" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" :rowKey="(record, index) => (record.materialNo + index)"
                      :scroll="{ fixScreen: true, x: 1000, extraHeight: 100 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
          <!--摆场总需求-->
          <template slot="sumDemandQuantity" slot-scope="text">
            <a @click="onSumDemandQuantity(text.record)" href="javascript:;">{{ text.record.sumDemandQuantity }}</a>
          </template>
          <template slot="footer">
            <StickyFixedSummary
              ref="summaryRef"
              :footerTableColumns="columns"
              :columns="columns"
              :dateFiledList="dateFiledList" />
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import comparativeAnalysis from '@/views/scp/producingAndMarketing/furniture-placement-demand/analysis/components/comparative-analysis'
import {
  apiAnalysisExport,
  apiAnalysisList,
  placementSum
} from '@/api/scp/pre-order-and-placement/pre-order-and-placement'
import StickyFixedSummary from '@/components/StickyFixedSummary'

export default {
  name: 'Analysis',
  components: { DownloadModal, comparativeAnalysis, StickyFixedSummary },
  data() {
    return {
      isOpen: false, // 控制年份浮窗显示和关闭
      statusList: [], // 状态
      apiAnalysisExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiAnalysisList, false),
        pageCurrent: true
      },
      dateForm: { dateOne: '', dateTwo: '' }, // 差异对比日期
      // 查询参数
      queryParams: {
        materialNo: undefined,
        projectTeamName: undefined,
        mainModel: undefined,
        promotionName: undefined,
        planUserName: undefined,
        submitYear: undefined,
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '物料编码', decorator: ['materialNo'], type: 'input' },
        { label: '项目组', decorator: ['projectTeamName'], type: 'input' },
        { label: '主型号', decorator: ['mainModel'], type: 'input' },
        { label: '促销名称', decorator: ['promotionName'], type: 'statusList' },
        { label: '计划员', decorator: ['planUserName'], type: 'input' },
        { label: '年份', decorator: ['submitYear'], type: 'submitYear' },
        { label: '提报日期', decorator: ['submitTime'], type: 'submitTime' }
      ],
      // 表格字段
      columns: [
        { title: '物料编码', dataIndex: 'materialNo', align: 'center', width: 160 },
        { title: '物料名称', dataIndex: 'materialName', align: 'center', width: 120, ellipsis: true },
        { title: '规格描述', dataIndex: 'materialSpec', align: 'center', width: 180, ellipsis: true },
        { title: '计划员', dataIndex: 'planUserName', align: 'center', width: 100, ellipsis: true },
        { title: '主型号', dataIndex: 'mainModel', align: 'center', width: 110 },
        { title: '项目组', dataIndex: 'projectTeamName', align: 'center', width: 120 },
        { title: '促销名称', dataIndex: 'promotionName', align: 'center', width: 120 },
        { title: '提报日期', dataIndex: 'submitTime', align: 'center', scopedSlots: { customRender: 'dateFormat' }, width: 120, ellipsis: true },
        { title: '摆场总需求', dataIndex: 'sumDemandQuantity', scopedSlots: { customRender: 'sumDemandQuantity' }, align: 'center', width: 120 },
        { title: '比前一天变化', dataIndex: 'demandQuantityChange', align: 'center', width: 100 },
        { title: '所选日期需求差异值', dataIndex: 'choseDayDemandDifferenceQuantity', align: 'center', width: 100 }
      ],
      dateFiledList: [
        { title: '摆场总需求', dataIndex: 'sumDemandQuantity', align: 'center', width: 120 }
      ],
      sumInfoList: [{}]
    }
  },
  created() {
    // 汇总表跳转迭代参数(默认查当前年份)
    this.queryParams.submitYear = this.$route?.query?.submitYear ? this.$route.query.submitYear : new Date().getFullYear().toString();
    this.queryParams.promotionName = this.$route?.query?.promotionName ? this.$route.query.promotionName : undefined;
    this.getLookupList('SCP_PLACEMENT_PROMOTION_NAME', 'statusList')
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs?.dataTable) this.$refs.summaryRef.initSet(this.$refs.dataTable)
    })
    this.onSearch()
  },
  methods: {
    // 年份选择后回调
    panelChange(value) {
      this.queryParams.submitYear = value ? this.$moment(value).format('YYYY') : '';
      this.isOpen = false;
    },
    // 控制年份浮窗显示和关闭
    onOpenChange(val) {
      this.isOpen = !!val
    },
    // 跳转详情页
    onSumDemandQuantity(data) {
      console.log(data)
      this.$router.push(
        {
          path: '/scp/furniture-placement-demand/demand-detail',
          query: { submitTime: data.submitTime ? this.$moment(data.submitTime).format('YYYY-MM-DD') : '', promotionName: data.promotionName }
        }
      )
    },
    // 获取快码
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows?.length > 0) {
          this[arr] = response.rows
        }
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      if (this.dateForm?.dateOne && this.dateForm?.dateTwo) {
        params.demandDateBegin = this.dateForm.dateOne + " 00:00:00"
        params.demandDateEnd = this.dateForm.dateTwo + " 23:59:59"
      }
      params.submitTimeStart = params.submitTime && params.submitTime[0] ? (params.submitTime[0] + " 00:00:00") : undefined
      params.submitTimeEnd = params.submitTime && params.submitTime[1] ? (params.submitTime[1] + " 23:59:59") : undefined
      const queryObj = cloneDeep(params)
      if (queryObj?.submitTime) { delete queryObj.submitTime }
      this.$refs.dataTable.searchParams = queryObj
      if (this.$refs?.summaryRef) this.$refs.summaryRef.summaryFromApi(queryObj, placementSum)
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        materialNo: undefined,
        projectTeamName: undefined,
        mainModel: undefined,
        promotionName: undefined,
        planUserName: undefined,
        submitYear: undefined,
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 选择日期后回调显示
    handleChooseDate(form) {
      this.$set(this.dateForm, 'dateOne', form?.dateOne)
      this.$set(this.dateForm, 'dateTwo', form?.dateTwo)
      this.onSearch()
    },
    // 差异对比
    handleCompareBtn() {
      this.$refs.comparativeAnalysisRef.show();
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../../../components/StickyFixedSummary/styles/footerTable.less';
.compare-date{
  color:#f5222d;
  padding-left:20px;
  .choose-data{
    font-weight: 700;
  }
}
.footerTable{
  /deep/.ant-table-tbody{
    tr{
      td{
        padding: 5px 10px
      }
    }
  }
}
.year-picker-css{
  width: 100%;
}
</style>
